<div class="pillars-container">
  <div class="heading-container">
    <div class="heading">
      <h1>
        Four Pillars for <span class="highlight">Seamless </span>
        School Management
      </h1>
    </div>
    <p>
      Discover how People, Finance, Classroom, and Communication work together
      to simplify school management and drive success.
    </p>
    <button (click)="goToPage()">Book Free Demo</button>
    <div *ngIf="logoUrl?.length">
      <div class="carousel-container">
        <div class="carousel-images">
          <!-- <ng-image-slider
            [imageSize]="getImgSize()"
            [autoSlide]="autoSlide"
            [infinite]="infiniteSlide"
            [showArrow]="false"
            [animationSpeed]="1"
            [images]="logoUrl"
            #gallery
          ></ng-image-slider> -->
          <div class="marquee-wrapper">
            <om-marquee [animationDuration]="'40s'">
              <div
                class="marquee-card"
                *ngFor="let logo of logoUrl"
                #OmMarqueeContent
              >
                <img [src]="logo.url" class="school-logos" />
              </div>
            </om-marquee>
            <div class="marquee-gradient left"></div>
            <div class="marquee-gradient right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="feature-wrapper">
    <div
      class="feature-container"
      *ngFor="let card of featuresCard"
      [ngClass]="{ reverse: card.isReversed }"
    >
      <div class="feature-text">
        <h2>
          <span class="highlight">{{ card.title }}</span>
        </h2>
        <div class="description-wrapper" *ngFor="let text of card.description">
          <!-- <p>{{ card.description }}</p> -->
          <span class="bullet">▹</span>
          <span [innerHTML]="text" class="des-text"></span>
        </div>
      </div>
      <div class="feature-image">
        <img [src]="card.imageUrl" alt="{{ card.title }}" />
      </div>
    </div>
  </div>
</div>
